export const generateHeadingId = (str) => {
    return `h-${str.split(' ').join('-').toLowerCase()}`;
};
